import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CandlestickChart, LogOut, Crown, Shield, Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import NotificationBell from "./NotificationBell";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  if (!user) return null;

  const LINKS = [
    { to: "/dashboard", label: "Segnali", testid: "nav-dashboard" },
    { to: "/network", label: "Network", testid: "nav-network" },
    { to: "/championship", label: "Championship", testid: "nav-championship" },
    { to: "/lottery", label: "Lotteria", testid: "nav-lottery" },
    { to: "/trading", label: "NFP", testid: "nav-trading" },
    { to: "/about", label: "Chi Siamo", testid: "nav-about" },
    { to: "/contact", label: "Contatti", testid: "nav-contact" },
    { to: "/pricing", label: "Premium", testid: "nav-pricing" },
  ];
  // CRYPTO and Learning are currently visible to admins only.
  if (user.role === "admin") {
    LINKS.splice(2, 0, { to: "/wallet", label: "CRYPTO", testid: "nav-wallet" });
    LINKS.splice(4, 0, { to: "/learning", label: "Learning", testid: "nav-learning" });
    LINKS.push({ to: "/admin", label: "Admin", testid: "nav-admin" });
  }

  const active = (to) => (loc.pathname === to ? "text-white" : "text-zinc-400 hover:text-white");

  const roleBadge = () => {
    if (user.role === "admin") {
      return (
        <span className="hidden sm:flex items-center gap-1 text-xs font-mono px-2 py-1 rounded-sm bg-blue-500/15 text-blue-400">
          <Shield size={12} /> ADMIN
        </span>
      );
    }
    if (user.is_premium) {
      return (
        <span className="hidden sm:flex items-center gap-1 text-xs font-mono px-2 py-1 rounded-sm bg-amber-500/15 text-amber-400">
          <Crown size={12} /> PREMIUM
        </span>
      );
    }
    return null;
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/dashboard" data-testid="navbar-logo" className="flex items-center gap-2">
          <CandlestickChart size={22} className="text-blue-500" strokeWidth={2.5} />
          <span className="font-bold tracking-tight text-lg">Raein<span className="text-blue-500">Exchange</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-5">
          {LINKS.map((l) => (
            <Link key={l.to} data-testid={l.testid} to={l.to}
              className={`text-sm font-medium transition-colors ${active(l.to)}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <NotificationBell />
          {roleBadge()}
          <div className="hidden sm:block text-sm text-zinc-300 max-w-[140px] truncate">
            <Link to="/profile" data-testid="nav-profile" className="hover:text-white transition-colors">
              {user.name || user.email}
            </Link>
          </div>
          <button data-testid="logout-btn" onClick={async () => { await logout(); navigate("/"); }}
            className="p-2 rounded-md hover:bg-white/5 transition-colors" title="Esci">
            <LogOut size={18} className="text-zinc-400" />
          </button>
          <button className="md:hidden p-2 text-zinc-300" onClick={() => setOpen(!open)} data-testid="navbar-menu-toggle">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="navbar-mobile-menu" className="md:hidden border-t border-white/10 px-6 py-4 flex flex-col gap-3 bg-black/90">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`m-${l.testid}`} onClick={() => setOpen(false)}
              className={`text-sm font-medium transition-colors ${active(l.to)}`}>
              {l.label}
            </Link>
          ))}
          <Link to="/profile" data-testid="m-nav-profile" onClick={() => setOpen(false)}
            className={`text-sm font-medium transition-colors ${active("/profile")}`}>
            Profilo
          </Link>
        </nav>
      )}
    </header>
  );
}
